import { render, staticRenderFns } from "./partner-ad-banner.vue?vue&type=template&id=1e254f73&scoped=true"
import script from "./partner-ad-banner.vue?vue&type=script&lang=js"
export * from "./partner-ad-banner.vue?vue&type=script&lang=js"
import style0 from "./partner-ad-banner.vue?vue&type=style&index=0&id=1e254f73&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e254f73",
  null
  
)

export default component.exports